import { useEffect } from 'react';

type HeadMetaDataProps = {
  title: string;
  description: string;
};

const HeadMetaData = ({ title, description }: HeadMetaDataProps) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'description';
    meta.content = description;
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, [description]);

  return null;
};

export default HeadMetaData;
